import axios from "axios";
export default {
  getUserProfile: () => {
    return axios.get("api/admin/users/profile");
  },
};
